const acceptanceStageId = 3;
const ManagementStageId = 4;
export const stageIdsForAcceptanceStatuses = new Set([
  acceptanceStageId,
  ManagementStageId,
]);
